import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { userSelector } from '../../redux/user/selector';
import { updateSessionsTime } from '../../redux/consultations/newList.reducer';

const refreshInterval = 10 * 1000;

export const useUpdateSessionsTime = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const client = useSelector(userSelector);
  const [intervalRef, setIntervalRef] = useState<NodeJS.Timeout>();

  useEffect(() => {
    if (!intervalRef && client?.id) {
      setIntervalRef(
        setInterval(() => {
          const urlName = 'tabs/schedule';
          const needToUpdate =
            document?.location?.href?.includes(urlName) ||
            document?.location?.pathname?.includes(urlName) ||
            window?.location?.pathname?.includes(urlName) ||
            location?.pathname?.includes(urlName);

          if (needToUpdate) {
            dispatch(updateSessionsTime());
          }
        }, refreshInterval)
      );
    }
  }, [client?.id]);

  return () => {
    if (intervalRef) {
      clearInterval(intervalRef);
      setIntervalRef(undefined);
    }
  };
};
